<template lang="pug">
  .product-display(
    v-if="product"
  )
    .product-display__wrapper
      .container
        .row
          .small-12.medium-5.column
            product-media-gallery(
              :product="product"
              :images="product.images",
            )
            product-accordians(
              v-if="$mq !== 'mobile'"
              :product="product"
              id="more_details_accordion"
              class="product-display__product-accordion"
            )
          .small-12.medium-7.column
            .product-info-container
              product-info(
                :product="product"
                :title-image="titleImage"
              )
              product-form-gift-card(v-if="product.type === 'Gift Card'" :product="product")
              product-form(
                v-else
                :product="product"
              )
              slot(name="promo-image")
              product-accordians(
                v-if="$mq === 'mobile'"
                :product="product"
                id="more_details_accordion"
                class="product-display__product-accordion"
              )
</template>

<script>
  import ProductInfo from 'scripts/components/product/ProductInfo.vue';
  import ProductForm from 'scripts/components/product/ProductForm.vue';
  import ProductFormGiftCard from 'scripts/components/product/ProductFormGiftCard.vue';
  import ProductMediaGallery from 'scripts/components/product/ProductMediaGallery.vue';
  import ProductAccordians from 'scripts/components/product/ProductAccordians.vue';
  import Icon from 'scripts/components/basic/Icon.vue';

  export default {
    name: 'ProductDisplay',
    components: { ProductInfo, ProductForm, ProductFormGiftCard, ProductMediaGallery, ProductAccordians, Icon },
    props: {
      product: Object,
      titleImage: String,
    },
    computed: {},
    mounted() {
      // wait for the display to render, then initialize yotpo
      if (window.yotpo) {
        const interval = setInterval(() => {
          if (window.yotpo.initialized && this.$refs.productDisplay) {
            const api = new window.Yotpo.API(window.yotpo);
            api.refreshWidgets();
            clearInterval(interval);
          }
        }, 1000);
      }
    },
  };
</script>

<style scoped lang="scss">
  .product-display {
    position: relative;
    z-index: index($layout, 'page-layout-content');
    padding: ($spacing-unit * 15) 0;
  }

  .product-display__wrapper {
    position: relative;
    z-index: index($product-display, 'content');

    .container {
      max-width: 1440px;
    }
  }

  .product-info-container {
    position: sticky;
    top: $desktop-nav-height;
  }

  .product-display__product-accordion {
    scroll-margin-top: 0;
    padding-top: $mobile-scroll-margin;

    @include desktop-up {
      padding-top: 0;
      scroll-margin-top: $desktop-scroll-margin;
    }
  }
</style>
